import Flex from "@/components/Flex";
import Text from "@/components/Text";
import DeleteIcon from "@/components/app/DeleteIcon";
import HomeCareRosOptions from "@/pages/app/admin/library/templates/home-care-ros/components/HomeCareRosOptions";
import HomeCareRosSafetyAssessment from "@/pages/app/admin/library/templates/home-care-ros/components/HomeCareRosSafetyAssessment";
import HomeCareRosSystemRow from "@/pages/app/admin/library/templates/home-care-ros/components/HomeCareRosSystemRow";
import { HOME_CARE_ROS_TABLE_SX } from "@/pages/app/admin/library/templates/home-care-ros/home-care-ros-constant";
import {
  HOME_CARE_ROS_OPTIONS,
  HOME_CARE_ROS_SAFETY_ASSESSMENT,
} from "@/pages/app/admin/library/templates/home-care-ros/home-care-ros-data";
import { RosAndPe } from "../../encounter-constant";

export interface HomeCareRosImportListProps {
  items: RosAndPe[];
  onDescriptionChange: (value: string, index: number) => void;
  onRemove: (index: number) => void;
}

const HomeCareRosImportList = ({
  items,
  onDescriptionChange,
  onRemove,
}: HomeCareRosImportListProps) => (
  <Flex flexDirection="column" width="100%" sx={HOME_CARE_ROS_TABLE_SX}>
    {items.map((item, index) => {
      if (!item.isSelected) return null;
      const name = item.templateNameType ?? "";
      const catalog = HOME_CARE_ROS_OPTIONS[name];
      return (
        <HomeCareRosSystemRow
          key={name}
          name={name}
          action={<DeleteIcon onClick={() => onRemove(index)} />}
        >
          {name === HOME_CARE_ROS_SAFETY_ASSESSMENT ? (
            <HomeCareRosSafetyAssessment
              value={item.description}
              onChange={(next) => onDescriptionChange(next, index)}
            />
          ) : catalog ? (
            <HomeCareRosOptions
              catalog={catalog}
              value={item.description}
              onChange={(next) => onDescriptionChange(next, index)}
            />
          ) : (
            <Text>{item.description}</Text>
          )}
        </HomeCareRosSystemRow>
      );
    })}
  </Flex>
);

export default HomeCareRosImportList;
